/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import { NavLink } from "react-router-dom";

import { ChevronsLeftIcon, ChevronsRightIcon } from "lucide-react";
import { Collapse } from "react-bootstrap";
import { Routes } from "../../AppRoutes";
import { Header } from "../../components/header";

const MenuWithChildren = (props: any) => {
  const { onClick, show, menu, childrens } = props;
  return (
    <div>
      <a onClick={onClick} role="presentation">
        {menu.icon}
        {menu.title}
      </a>
      <Collapse in={show}>
        <div className="pl-4 ml-1">
          {childrens.map((item: any) => (
            <NavLink className="!w-full" to={item.path} key={item.path}>
              {item.title}
            </NavLink>
          ))}
        </div>
      </Collapse>
    </div>
  );
};

const DocumentMenu = () => {
  const [show, set] = useState(true);
  return (
    <MenuWithChildren
      menu={Routes.settingDocument}
      childrens={[
        Routes.settingDocumentType,
        Routes.settingDocumentDepartment,
        // Routes.settingMemberGroup,
        Routes.settingDecentralizationPage,
        Routes.settingDocumentTagType,
        Routes.settingDepartmentList,
      ]}
      show={show}
      onClick={() => set(!show)}
    />
  );
};

export const withProcedureWraper = (Component: any) => (props: any) => {
  const [showMenu, setShowMenu] = useState(true);

  const onHideMenu = () => {
    setShowMenu(!showMenu);
  };

  return (
    <>
      <Header /> (
      <>
        <div className={showMenu ? "Menu__Navgiator" : "Menu__Navgiator-hide"}>
          <DocumentMenu />
        </div>
        <div className={showMenu ? "Main__Content" : "Main__Content-hide"}>
          <Component {...props} />

          <div className="relative z-100">
            <button
              className="absolute top-10 z-100 flex !h-8 !w-8 !min-w-8 -translate-x-2/4 items-center justify-center rounded-full border border-primary-default bg-white text-primary-default transition-all hover:!bg-opacity-70"
              onClick={onHideMenu}
            >
              {showMenu ? <ChevronsLeftIcon size={16} /> : <ChevronsRightIcon size={16} />}
            </button>
          </div>
        </div>
      </>
      )
    </>
  );
};
